import { Component, Input, OnInit } from "@angular/core";
import { JournalEntryViewModel } from "@tylertech/tyler-api-types";

interface Summary
{
    readonly key: string;
    debit: number;
    credit: number;
    amount: number;
}

@Component({
    selector: "gl-journal-entry-detail",
    templateUrl: "./glJournalEntryDetail.tmpl.html",
    styleUrls: [
        "./glJournalEntryDetail.component.scss"
    ],
    standalone: false
})
export class GlJournalEntryDetailComponent implements OnInit
{
    private readonly summaryByAccount = new Map<string, Summary>();

    @Input()
    detail: JournalEntryViewModel[];

    ngOnInit(): void
    {
        this.detail.forEach(element =>
        {
            element.Distributions.forEach(entry =>
            {
                if (!this.summaryByAccount.has(entry.AccountNumber))
                {
                    this.summaryByAccount.set(entry.AccountNumber, {
                        key: entry.AccountNumber,
                        debit: 0,
                        credit: 0,
                        amount: 0,
                    });
                }
                const summary = this.summaryByAccount.get(entry.AccountNumber);
                summary.amount += entry.Amount;
                if (entry.Amount < 0)
                {
                    summary.credit += entry.Amount;
                }
                else
                {
                    summary.debit += entry.Amount;
                }
            });
        });
    }

    get summaries(): Array<Summary>
    {
        return Array.from(this.summaryByAccount.values());
    }
}
